export const serviceVisualPresets = [
  { key: 'cleaning_basic', name: 'Базовая уборка' },
  { key: 'cleaning_deep', name: 'Генеральная / комплексная уборка' },
  { key: 'cleaning_seasonal', name: 'Сезонная уборка' },
  { key: 'search_basic', name: 'Поиск захоронения' },
  { key: 'search_extended', name: 'Расширенный поиск' },
  { key: 'grave_condition_analysis', name: 'Анализ состояния захоронения' },
  { key: 'monument_wash', name: 'Мойка памятника' },
  { key: 'monument_repair', name: 'Ремонт / восстановление памятника' },
  { key: 'inscription_restore', name: 'Коррекция / восстановление надписей' },
  { key: 'fence_paint', name: 'Покраска ограды' },
  { key: 'fence_repair', name: 'Ремонт ограды' },
  { key: 'cross_paint', name: 'Покраска креста' },
  { key: 'improvement_general', name: 'Благоустройство' },
  { key: 'tile_care', name: 'Плитка / мощение' },
  { key: 'soil_gravel', name: 'Отсыпка / грунт / щебень' },
  { key: 'weed_removal', name: 'Удаление травы / сорняков' },
  { key: 'flowers_bouquet', name: 'Цветы / букет' },
  { key: 'flowers_planting', name: 'Посадка цветов' },
  { key: 'candle_lantern', name: 'Лампада / свеча' },
  { key: 'universal_service', name: 'Универсальный / индивидуальный заказ' },
];

export const getServiceVisualPreset = (key) => (
  serviceVisualPresets.find((preset) => preset.key === key) || null
);
